export const BAD_USER_INPUT = 'BAD_USER_INPUT';

export const EMPTY_INVENTORY_ERROR = '$emptyInventory';
